import React, { useContext, useMemo } from 'react';
import { DateTime, Info } from 'luxon';
import CalendarContext from '../CalendarContext';
import Square from '../Square';
import { Grid } from './styled';
function DayView() {
    const { date, value, onChange, setDate, max, min, disabledDate } = useContext(CalendarContext);
    const today = useMemo(() => DateTime.now().startOf('day'), []);
    const weekdays = useMemo(() => Info.weekdays('long').map((day) => (React.createElement(Square, { "$readOnly": true, key: day }, day[0]))), []);
    const previousMonthDays = useMemo(() => {
        const first = date.startOf('month');
        const weekday1st = date.startOf('month').weekday;
        return new Array(weekday1st - 1).fill('').map((_, index) => {
            const current = first.minus({ days: weekday1st - index - 1 });
            const label = current.toLocaleString(DateTime.DATE_HUGE);
            const key = current.toLocaleString();
            const disabled = current > DateTime.fromJSDate(max) ||
                current < DateTime.fromJSDate(min) ||
                disabledDate(current.toJSDate());
            return (React.createElement(Square, { key: key, "aria-label": label, "$gray": true, disabled: disabled, "$altDisabled": disabled, onClick: () => {
                    setDate(current);
                    onChange(current.toJSDate());
                } }, current.day));
        });
    }, [date, setDate, onChange, max, min, disabledDate]);
    const currentMonthDays = useMemo(() => {
        const first = date.startOf('month');
        return new Array(date.daysInMonth).fill('').map((_, index) => {
            const current = first.plus({ days: index });
            const label = current.toLocaleString(DateTime.DATE_HUGE);
            const key = current.toLocaleString();
            const disabled = current > DateTime.fromJSDate(max) ||
                current < DateTime.fromJSDate(min) ||
                disabledDate(current.toJSDate());
            const isToday = current.toISODate() === today.toISODate();
            const selected = current.toISODate() ===
                DateTime.fromJSDate(value).startOf('day').toISODate();
            return (React.createElement(Square, { key: key, "aria-label": label, "$today": isToday, selected: selected, disabled: disabled, "$altDisabled": disabled, onClick: () => {
                    onChange(current.toJSDate());
                } }, current.day));
        });
    }, [date, today, value, onChange, max, min, disabledDate]);
    const nextMonthDays = useMemo(() => {
        const last = date.endOf('month').startOf('day');
        const weekdayLast = last.weekday;
        return new Array(7 - weekdayLast).fill('').map((_, index) => {
            const current = last.plus({ days: index + 1 });
            const label = current.toLocaleString(DateTime.DATE_HUGE);
            const key = current.toLocaleString();
            const disabled = current > DateTime.fromJSDate(max) ||
                current < DateTime.fromJSDate(min) ||
                disabledDate(current.toJSDate());
            return (React.createElement(Square, { "$gray": true, key: key, "aria-label": label, disabled: disabled, "$altDisabled": disabled, onClick: () => {
                    setDate(current);
                    onChange(current.toJSDate());
                } }, current.day));
        });
    }, [date, setDate, onChange, max, min, disabledDate]);
    return (React.createElement(Grid, { view: "day" },
        weekdays,
        previousMonthDays,
        currentMonthDays,
        nextMonthDays));
}
export default DayView;
